import React from 'react'

import i18n from 'i18next'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

import { SlideActionMode } from './slide-panel-types'

type SlideActionModalProps = {
  visible: boolean
  mode: SlideActionMode | null
  title: string
  slideName: string
  onChange: (value: string) => void
  onOk: () => void
  onCancel: () => void
  isSubmitting?: boolean
}

const SlideActionModal = ({
  visible,
  mode,
  title,
  slideName,
  onChange,
  onOk,
  onCancel,
  isSubmitting = false
}: SlideActionModalProps) => {
  const okText =
    mode === 'delete'
      ? i18n.t('action.delete')
      : mode === 'duplicate'
      ? i18n.t('editor.left-panel.slides.duplicate-action')
      : i18n.t('action.save')
  const isDestructive = mode === 'delete'
  const description =
    mode === 'name'
      ? i18n.t('editor.left-panel.slides.description-prompt')
      : i18n.t('editor.left-panel.slides.confirm-prompt')

  return (
    <Dialog
      open={visible}
      onOpenChange={open => {
        if (!open) onCancel()
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="indico-dialog-body">
          {mode === 'name' && (
            <div className="indico-dialog-field">
              <input
                className="indico-dialog-input"
                placeholder={i18n.t('editor.left-panel.slides.description-placeholder')}
                value={slideName}
                onChange={event => onChange(event.target.value)}
                onKeyDown={event => {
                  if (event.key === 'Enter') onOk()
                }}
                autoFocus
              />
              {slideName && (
                <button
                  type="button"
                  className="indico-dialog-clear"
                  onClick={() => onChange('')}
                  disabled={isSubmitting}
                >
                  {i18n.t('action.clear')}
                </button>
              )}
            </div>
          )}
        </div>
        <DialogFooter>
          <button
            type="button"
            className="indico-dialog-button"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            {i18n.t('action.cancel')}
          </button>
          <button
            type="button"
            className={`indico-dialog-button ${
              isDestructive ? 'indico-dialog-button-danger' : 'indico-dialog-button-primary'
            }`}
            onClick={onOk}
            disabled={isSubmitting}
          >
            {okText}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SlideActionModal
